module.exports = __webpack_public_path__ + "img/screenshot-1.b2e4ba61.png";